function showButtons() {

	var maxHeight = 0;

	for (var i = 1; i < 13; i++) {
		buttonsContainers[i].style.height = "";
		buttonsContainers[i].style.fontSize = "32px";
		buttonsContainers[i].innerHTML = listArrays[allColumns.indexOf('button' + i)][trialRow];
		buttonsContainers[i].style.visibility = "hidden";
	}

	buttonHeight = $('#button1').height();

	setResponseTopPositionCustomButtons(); //compute where we should display the buttons

	switch (listNoButtons[trialRow]) {
		case 1:
			buttonsContainers[1].style.width = width1button + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			if (listArrays[allColumns.indexOf('test')][trialRow] == "CFPT") {
				buttonsContainers[1].style.top = "85%";
			}
			buttonsContainers[1].style.left = (canvasWidth / 2 - width1button / 2) + "px";
			buttonsContainers[1].style.display = "block";
			break;
		case 2:
			buttonsContainers[1].style.width = width2buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - space2buttons / 2 - width2buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width2buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 + space2buttons / 2) + "px";
			buttonsContainers[2].style.display = "block";
			break;
		case 3:
			buttonsContainers[1].style.width = width3buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - width3buttons / 2 - space3buttons - width3buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width3buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - width3buttons / 2) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width3buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 + width3buttons / 2 + space3buttons) + "px";
			buttonsContainers[3].style.display = "block";
			break;
		case 4:
			buttonsContainers[1].style.width = width4buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 3 * space4buttons / 2 - 2 * width4buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width4buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - space4buttons / 2 - width4buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width4buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 + space4buttons / 2) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width4buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 + 3 * space4buttons / 2 + width4buttons) + "px";
			buttonsContainers[4].style.display = "block";
			break;
		case 5:
			buttonsContainers[1].style.width = width5buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 2 * space5buttons - 2.5 * width5buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width5buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - space5buttons - 1.5 * width5buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width5buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - width5buttons / 2) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width5buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 + space5buttons + width5buttons / 2) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width5buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 + 2 * space5buttons + 1.5 * width5buttons) + "px";
			buttonsContainers[5].style.display = "block";
			break;
		case 6:
			buttonsContainers[1].style.width = width6buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 2.5 * space6buttons - 3 * width6buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width6buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 1.5 * space6buttons - 2 * width6buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width6buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - space6buttons / 2 - width6buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width6buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 + space6buttons / 2) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width6buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 + 1.5 * space6buttons + width6buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width6buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 + 2.5 * space6buttons + 2 * width6buttons) + "px";
			buttonsContainers[6].style.display = "block";
			break;
		case 7:
			buttonsContainers[1].style.width = width7buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 3 * space7buttons - 3.5 * width7buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width7buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 2 * space7buttons - 2.5 * width7buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width7buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - space7buttons - 1.5 * width7buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width7buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - 0.5 * width7buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width7buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 + space7buttons + 0.5 * width7buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width7buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 + 2 * space7buttons + 1.5 * width7buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width7buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + 3 * space7buttons + 2.5 * width7buttons) + "px";
			buttonsContainers[7].style.display = "block";
			break;
		case 8:
			buttonsContainers[1].style.width = width8buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 3.5 * space8buttons - 4 * width8buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width8buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 2.5 * space8buttons - 3 * width8buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width8buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - 1.5 * space8buttons - 2 * width8buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width8buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - 0.5 * space8buttons - width8buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width8buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 + 0.5 * space8buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width8buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 + 1.5 * space8buttons + width8buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width8buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + 2.5 * space8buttons + 2 * width8buttons) + "px";
			buttonsContainers[7].style.display = "block";
			buttonsContainers[8].style.width = width8buttons + "px";
			buttonsContainers[8].style.top = currentButtonTop + "px";
			buttonsContainers[8].style.left = (canvasWidth / 2 + 3.5 * space8buttons + 3 * width8buttons) + "px";
			buttonsContainers[8].style.display = "block";
			break;
		case 9:
			buttonsContainers[1].style.width = width9buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 4 * space9buttons - 4.5 * width9buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width9buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 3 * space9buttons - 3.5 * width9buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width9buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - 2 * space9buttons - 2.5 * width9buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width9buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - space9buttons - 1.5 * width9buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width9buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 - 0.5 * width9buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width9buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 + space9buttons + 0.5 * width9buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width9buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + 2 * space9buttons + 1.5 * width9buttons) + "px";
			buttonsContainers[7].style.display = "block";
			buttonsContainers[8].style.width = width9buttons + "px";
			buttonsContainers[8].style.top = currentButtonTop + "px";
			buttonsContainers[8].style.left = (canvasWidth / 2 + 3 * space9buttons + 2.5 * width9buttons) + "px";
			buttonsContainers[8].style.display = "block";
			buttonsContainers[9].style.width = width9buttons + "px";
			buttonsContainers[9].style.top = currentButtonTop + "px";
			buttonsContainers[9].style.left = (canvasWidth / 2 + 4 * space9buttons + 3.5 * width9buttons) + "px";
			buttonsContainers[9].style.display = "block";
			break;
		case 10:
			buttonsContainers[1].style.width = width10buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 4.5 * space10buttons - 5 * width10buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width10buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 3.5 * space10buttons - 4 * width10buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width10buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - 2.5 * space10buttons - 3 * width10buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width10buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - 1.5 * space10buttons - 2 * width10buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width10buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 - 0.5 * space10buttons - width10buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width10buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 + 0.5 * space10buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width10buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + 1.5 * space10buttons + width10buttons) + "px";
			buttonsContainers[7].style.display = "block";
			buttonsContainers[8].style.width = width10buttons + "px";
			buttonsContainers[8].style.top = currentButtonTop + "px";
			buttonsContainers[8].style.left = (canvasWidth / 2 + 2.5 * space10buttons + 2 * width10buttons) + "px";
			buttonsContainers[8].style.display = "block";
			buttonsContainers[9].style.width = width10buttons + "px";
			buttonsContainers[9].style.top = currentButtonTop + "px";
			buttonsContainers[9].style.left = (canvasWidth / 2 + 3.5 * space10buttons + 3 * width10buttons) + "px";
			buttonsContainers[9].style.display = "block";
			buttonsContainers[10].style.width = width10buttons + "px";
			buttonsContainers[10].style.top = currentButtonTop + "px";
			buttonsContainers[10].style.left = (canvasWidth / 2 + 4.5 * space10buttons + 4 * width10buttons) + "px";
			buttonsContainers[10].style.display = "block";
			break;
		case 11:
			buttonsContainers[1].style.width = width11buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 5 * space11buttons - 5.5 * width11buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width11buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 4 * space11buttons - 4.5 * width11buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width11buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - 3 * space11buttons - 3.5 * width11buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width11buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - 2 * space11buttons - 2.5 * width11buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width11buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 - space11buttons - 1.5 * width11buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width11buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 - 0.5 * width11buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width11buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + space11buttons + 0.5 * width11buttons) + "px";
			buttonsContainers[7].style.display = "block";
			buttonsContainers[8].style.width = width11buttons + "px";
			buttonsContainers[8].style.top = currentButtonTop + "px";
			buttonsContainers[8].style.left = (canvasWidth / 2 + 2 * space11buttons + 1.5 * width11buttons) + "px";
			buttonsContainers[8].style.display = "block";
			buttonsContainers[9].style.width = width11buttons + "px";
			buttonsContainers[9].style.top = currentButtonTop + "px";
			buttonsContainers[9].style.left = (canvasWidth / 2 + 3 * space11buttons + 2.5 * width11buttons) + "px";
			buttonsContainers[9].style.display = "block";
			buttonsContainers[10].style.width = width11buttons + "px";
			buttonsContainers[10].style.top = currentButtonTop + "px";
			buttonsContainers[10].style.left = (canvasWidth / 2 + 4 * space11buttons + 3.5 * width11buttons) + "px";
			buttonsContainers[10].style.display = "block";
			buttonsContainers[11].style.width = width11buttons + "px";
			buttonsContainers[11].style.top = currentButtonTop + "px";
			buttonsContainers[11].style.left = (canvasWidth / 2 + 5 * space11buttons + 4.5 * width11buttons) + "px";
			buttonsContainers[11].style.display = "block";
			break;
		case 12:
			buttonsContainers[1].style.width = width12buttons + "px";
			buttonsContainers[1].style.top = currentButtonTop + "px";
			buttonsContainers[1].style.left = (canvasWidth / 2 - 5.5 * space12buttons - 6 * width12buttons) + "px";
			buttonsContainers[1].style.display = "block";
			buttonsContainers[2].style.width = width12buttons + "px";
			buttonsContainers[2].style.top = currentButtonTop + "px";
			buttonsContainers[2].style.left = (canvasWidth / 2 - 4.5 * space12buttons - 5 * width12buttons) + "px";
			buttonsContainers[2].style.display = "block";
			buttonsContainers[3].style.width = width12buttons + "px";
			buttonsContainers[3].style.top = currentButtonTop + "px";
			buttonsContainers[3].style.left = (canvasWidth / 2 - 3.5 * space12buttons - 4 * width12buttons) + "px";
			buttonsContainers[3].style.display = "block";
			buttonsContainers[4].style.width = width12buttons + "px";
			buttonsContainers[4].style.top = currentButtonTop + "px";
			buttonsContainers[4].style.left = (canvasWidth / 2 - 2.5 * space12buttons - 3 * width12buttons) + "px";
			buttonsContainers[4].style.display = "block";
			buttonsContainers[5].style.width = width12buttons + "px";
			buttonsContainers[5].style.top = currentButtonTop + "px";
			buttonsContainers[5].style.left = (canvasWidth / 2 - 1.5 * space12buttons - 2 * width12buttons) + "px";
			buttonsContainers[5].style.display = "block";
			buttonsContainers[6].style.width = width12buttons + "px";
			buttonsContainers[6].style.top = currentButtonTop + "px";
			buttonsContainers[6].style.left = (canvasWidth / 2 - 0.5 * space12buttons - width12buttons) + "px";
			buttonsContainers[6].style.display = "block";
			buttonsContainers[7].style.width = width12buttons + "px";
			buttonsContainers[7].style.top = currentButtonTop + "px";
			buttonsContainers[7].style.left = (canvasWidth / 2 + 0.5 * space12buttons) + "px";
			buttonsContainers[7].style.display = "block";
			buttonsContainers[8].style.width = width12buttons + "px";
			buttonsContainers[8].style.top = currentButtonTop + "px";
			buttonsContainers[8].style.left = (canvasWidth / 2 + 1.5 * space12buttons + width12buttons) + "px";
			buttonsContainers[8].style.display = "block";
			buttonsContainers[9].style.width = width12buttons + "px";
			buttonsContainers[9].style.top = currentButtonTop + "px";
			buttonsContainers[9].style.left = (canvasWidth / 2 + 2.5 * space12buttons + 2 * width12buttons) + "px";
			buttonsContainers[9].style.display = "block";
			buttonsContainers[10].style.width = width12buttons + "px";
			buttonsContainers[10].style.top = currentButtonTop + "px";
			buttonsContainers[10].style.left = (canvasWidth / 2 + 3.5 * space12buttons + 3 * width12buttons) + "px";
			buttonsContainers[10].style.display = "block";
			buttonsContainers[11].style.width = width12buttons + "px";
			buttonsContainers[11].style.top = currentButtonTop + "px";
			buttonsContainers[11].style.left = (canvasWidth / 2 + 4.5 * space12buttons + 4 * width12buttons) + "px";
			buttonsContainers[11].style.display = "block";
			buttonsContainers[12].style.width = width12buttons + "px";
			buttonsContainers[12].style.top = currentButtonTop + "px";
			buttonsContainers[12].style.left = (canvasWidth / 2 + 5.5 * space12buttons + 5 * width12buttons) + "px";
			buttonsContainers[12].style.display = "block";
			break;
	}

	var visibleButtons = [];

	for(var i = 1; i <= listNoButtons[window.trialRow]; i++){
		var currentButton = "#button" + i;
		var currentButtonHeight = $(currentButton).height() + 16;
		if (currentButtonHeight > maxHeight){
			maxHeight = currentButtonHeight;
		}
		visibleButtons[i-1] = buttonsContainers[i];
	}

	for(var i = 1; i <= listNoButtons[window.trialRow]; i++){
		buttonsContainers[i].style.height = maxHeight + "px";
	}

	window.fitTextToElementsGroup(visibleButtons);

	for (var i = 1; i < 13; i++){
		buttonsContainers[i].blur();
		buttonsContainers[i].style.visibility = "";
	}
}

function alignInstructionsButton() {
	var newTop = parseInt($('#content').css('top')) + parseInt($('#content').height());
	var oldTop = parseInt($('#button1').css('top'));
	if(newTop > oldTop){
		$('#button1').css('top', newTop + 'px');
	}
}

function alignParticipantInformationButton(){
	var newTop = parseInt($('#P_details').css('top')) + document.getElementById('P_details').clientHeight;
	var oldTop = parseInt($('#button1').css('top'));
	if(newTop > oldTop){
		$('#button1').css('top', newTop + 10 + 'px');
	}
}